import {
  KisiBrandConfig,
  KisiGroup,
  KisiGroupMapping,
  KisiPlace,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type KisiApiType = ReturnType<typeof kisiApi>;
const kisiApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    saveApiKey(clubId: number, apiKey: string) {
      return axiosInstance.put(`${clubPrefix}kisi/save-api-key/${apiKey}`);
    },
    brandConfig() {
      return axiosInstance.get<KisiBrandConfig>(
        `${clubPrefix}kisi/brand-config`,
      );
    },
    generateSignatureKey(_clubId?: number) {
      return axiosInstance.get<{ secretKey: string }>(
        `${clubPrefix}kisi/api-signature-key`,
      );
    },
    fetchPlaces(_clubId?: number) {
      return axiosInstance.get<KisiPlace[]>(`${clubPrefix}catalog/kisi/places`);
    },
    fetchGroups(_clubId?: number) {
      return axiosInstance.get<KisiGroup[]>(`${clubPrefix}catalog/kisi/groups`);
    },
    initialize(
      _clubId: number,
      kisiPlaceId: string,
      membershipToGroupMap: { [k: number]: string },
      facilityToGroupMap: { [k: number]: string },
    ) {
      return axiosInstance.post(`${clubPrefix}kisi/initialize`, {
        placeId: kisiPlaceId,
        membershipsToGroups: membershipToGroupMap,
        facilitiesToGroups: facilityToGroupMap,
      });
    },
    fetchGroupMappings(_clubId?: number) {
      return axiosInstance.get<KisiGroupMapping[]>(
        `${clubPrefix}kisi/group-mappings`,
      );
    },
    modify(params: {
      clubId: number;
      membershipId?: number;
      facilityId?: number;
      // Sending a null kisiGroupId removes the membership mapping
      kisiGroupId: string | null;
    }) {
      return axiosInstance.patch(`${clubPrefix}kisi/modify`, {
        ...params,
        clubId: undefined,
      });
    },
    resetAccess(_clubId: number, memberId: string) {
      return axiosInstance.put(`${clubPrefix}kisi/reset-access/${memberId}`);
    },
  };
};

export default kisiApi;
